export * from './configs/tolc';



// WEBPACK FOOTER //
// ./src/app/constants/configs.ts